export const color = {
  primaryDarker: '#db5435',
  primaryDark: '#f16545',
  primary: '#fb6b4a',
  primaryLight: '#f97d60',
  textDark: '#333',
  text: '#666',
  textLight: '#999',
  white: '#fff',
  grey: '#ccc',
  panel: '#f6f7fb',
  divider: '#D5D5D5',
}
export const spacing = {
  small: '10px',
  base: '20px',
  large: '30px',
  largePlus: '40px',
  super: '50px',
}
export const shape = {
  radiusSmall: '4px',
  radiusBase: '5px',
}
export const fontSize = {
  mini: '0.75rem', // NOTE: 12px on desktop
  small: '0.875rem', // NOTE: 14px on desktop
  base: '1rem', // NOTE: 16px on desktop
  medium: '1.125rem', // NOTE: 18px on desktop
  large: '1.5rem', // NOTE: 24px on desktop
  plus: '2.25rem', //NOTE: 36px on desktop
  super: '3rem', // NOTE: 48px on desktop
  bannerTitle: '2.5vw',
}
